// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiNotificationAttr/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiNotificationAttr/getRows', payload).then(getData);

export const getRow = (rowID) => http.get(`apiNotificationAttr/getRow&ID=${rowID}`).then(getData);

export const create = (row) => http.post('apiNotificationAttr/create', row).then(getData);

export const update = (row) => http.post('apiNotificationAttr/edit', row).then(getData);

export const remove = (row) => http.post('apiNotificationAttr/delete', row).then(getData);